import store from "store"

function getUserPayId() {
  const authenticatedUser = store.getState().authentication.authenticatedUser
  return authenticatedUser?.user_pay_id
}

export default getUserPayId
